module.exports = __webpack_public_path__ + "img/royal_flush_logo.7628dd69.png";